import { NotificacaoResponse } from './notificacoes-response';

export class NotificacoesRetornoResponse {
  quantidadeNaoVisualizadas: number;
  listaNotificacoesUltimos7Dias: NotificacaoResponse[];
  listaNotificacoesDemaisDias: NotificacaoResponse[];

  constructor() {
    this.listaNotificacoesUltimos7Dias = [];
    this.listaNotificacoesDemaisDias = [];
  }
}
